import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import CustomDrawer from './CustomDrawer'

const useStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  appBarSpacer: theme.mixins.toolbar,
}))

export default function Frame(props) {
  const classes = useStyle()

  return (
    <div className={classes.root}>
      <CssBaseline />
      <CustomDrawer
        theme={props.theme}
        icon={props.icon}
        setTheme={props.setTheme}
        setUser={props.setUser}
      ></CustomDrawer>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth='lg' className={classes.container}>
          {props.children}
        </Container>
      </main>
    </div>
  )
}
